import { Action } from 'redux';
import _ from 'underscore';

import { isSiteCountAndCloudAdminStatusSucceededAction } from '../actions/SiteCountAndCloudAdminStatusAction';
import { ISiteCountAndCloudAdminStatus } from '../serverApi/types/ISiteCountAndCloudAdminStatus';

const InitialState: ISiteCountAndCloudAdminStatus = {
    numberOfSites: 1,
    isCloudAdmin: false
};

export function siteCountAndCloudAdminStatusReducer(
  previousState: ISiteCountAndCloudAdminStatus = InitialState,
  action: Action
): ISiteCountAndCloudAdminStatus {
  if (isSiteCountAndCloudAdminStatusSucceededAction(action)) {
    if (action.siteInfo && !_.isEqual(action.siteInfo, previousState)) {
      return action.siteInfo;
    }
  }

  return previousState;
}
